/* unplugin-vue-components disabled */import { render } from "./MechanicalArmPoseRender.vue?vue&type=template&id=735ab88c&scoped=true"
import script from "./MechanicalArmPoseRender.vue?vue&type=script&lang=js"
export * from "./MechanicalArmPoseRender.vue?vue&type=script&lang=js"

import "./MechanicalArmPoseRender.vue?vue&type=style&index=0&id=735ab88c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735ab88c"]])

export default __exports__